import { CLOSE_FAB } from '@package/actions';

export default function fabReducer(state = [], action) {
  let newState = Object.assign([], state);

  switch (action.type) {
    case CLOSE_FAB:
      const index = newState.indexOf(action.item);
      if (index < 0) {
        newState.push(action.item);
      }
      break;
    default:
      break;
  }

  // return the modified state
  return newState;
}
